import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { useQuery, useMutation, gql } from '@apollo/client';

const GET_PRODUCTS = gql`
  query GetProducts {
    tbl_firm_sub_coop(order_by: {firm_main_code_n: asc}) {
      int_ID
      firm_main_code_n
      firm_sub_name_n
    }
  }
`;


const UPDATE_PRODUCT = gql`
mutation UpdateProduct(
 
  $firmNameC: String!
  $firmNameU: String!
  ) {
  update_tbl_firm_sub_coop(
    where: { firm_main_code_n: { _eq: $firmNameC} }
    _set: { firm_sub_name_n: $firmNameU, firm_main_code_n: $firmNameC}
  ) {
    affected_rows
  }
}
`; 

const AgencyUpdateTest = () => {
  const { loading, error, data, refetch } = useQuery(GET_PRODUCTS);
  const [updateProduct] = useMutation(UPDATE_PRODUCT);
  const [products, setProducts] = useState(data ? data.tbl_firm_sub_coop : []);
  const [firmNameU, setFirmNameU] = useState(null); 
  const [firmNameC, setfirmNameC] = useState ('');



  

  const textEditor = (props, rowData) => {
    const handleKeyPress = (e) => {
      if (e.keyCode === 13) {
        // Enter tuşuna basıldığında çalışacak işlemleri burada çağırın
        setFirmNameU(props.value);
        setfirmNameC(rowData.firm_main_code_n);
        
       
       
        
      }
    };
  
    return (
      <InputText
        type="text"
        value={props.value}
        onChange={(e) => props.editorCallback(e.target.value)}
        onKeyDown={handleKeyPress} // Enter tuşuna basıldığında handleKeyPress işlevi çalışacak
      />
    );
  };

  useEffect(() => {
    if (firmNameU !== null) {
      // Bu kod yalnızca firmNameU değiştiğinde çalışır
      handleCellEditComplete();
      console.log('firmNameU değişti:', firmNameU);
      console.log('firmNameC değişti:', firmNameC);
  
      // İşlemlerinizi burada gerçekleştirin, örneğin bir API çağrısı yapabilirsiniz
      // Örnek: makeApiCall(firmNameU);
    }
  }, [firmNameU]);
  

  const handleCellEditComplete = (e) => {
    // Hücre düzenleme işlemi tamamlandığında çalışacak işlemleri burada gerçekleştirin
       
   handleUpdate();
  };




 
     
        
        
     
  const onCellEditComplete = (e) => {
    const { field, data: rowData } = e;

    updateProduct({
      variables: {
        firmNameU: rowData.firm_sub_name_n,
        firm_main_code_n: rowData.firm_main_code_n, // Her satır için farklı firm_main_code_n
      },
    }).then(() => {
      refetch();
    });
  };
    
      

  

  const handleUpdate = () => { 
    
    updateProduct({
      variables: {
       
        firmNameU: firmNameU,
        firmNameC: firmNameC,
        
        
      },
    })
      .then(() => {
        window.alert("Firm updated successfully!");
        refetch();
        console.log(firmNameU)
        console.log(firmNameC)
      })
      .catch((error) => {
        console.error("Error updating firm:", error);
      });
  }; 

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;


  

  return (
    <div className="datatable-editing-demo">
      <div className="card p-fluid">
        <h5>Veri Tablosu Düzenleme</h5>

        <InputText className="w-full" 
    id="username" value={firmNameU}
   
    />
        <DataTable
          value={data.tbl_firm_sub_coop}
         // sortField="firm_main_code_n" // Sıralama yapılacak alan
         // sortOrder={1}
          editMode="cell"
         
         
          responsiveLayout="scroll"
        >
          <Column
            field="int_ID"
            header="ID"
            style={{ width: '25%' }}
         //   editor={textEditor}
           
          />
          <Column
            field="firm_main_code_n"
            header="Own Firm Main Code"
            style={{ width: '25%' }}
          //  editor={textEditor}
           
          />
   


<Column
  field="firm_sub_name_n"
  header="Own Firm Sub Type"
  style={{ width: '100%' }}
  editor={(props) => {
    const { rowData } = props;

    // setfirmNameC işlevini burada kullanabilirsiniz
    const firmMainCode = (firmMainCode) => {
      // firmMainCode'u kullanarak istediğiniz işlemi gerçekleştirin
      // Örnek: rowData'ya firmMainCode'u atama
     // setfirmNameC(rowData.firm_main_code_n);
    };

    return textEditor(props, rowData); // Diğer özellikleri bozmadan textEditor'ı çağırın
  }}
/>

<Column
          header={<span className="font-bold text-sm text-gray-900">Detail</span>}
          body={(rowData) => (
            <button
              onClick={() => {
                
                setfirmNameC(rowData.firm_main_code_n);
              }}
              className="p-1 rounded-full dark:text-gray-600 hover:dark:bg-gray-700 focus:dark:bg-gray-700"
            >
              <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
                <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
              </svg>
            </button>
          )}
          style={{ textAlign: 'center', width: '6rem' }}
        ></Column>

        
        </DataTable>
      </div>
    </div>
  );
};

export default AgencyUpdateTest;
